import { useEffect } from "react";
import { useBlocker as useRouterBlocker } from "react-router-dom";

// v5's history.block() replacement. react-router's data-router useBlocker
// only blocks in-app navigation (a <Link>/navigate() call); the
// beforeunload listener below still covers tab close/refresh, same as before.
const useBlocker = (blockCondition, message) => {
  const blocker = useRouterBlocker(
    ({ currentLocation, nextLocation }) =>
      !!blockCondition && currentLocation.pathname !== nextLocation.pathname
  );

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (blockCondition) {
        event.preventDefault();
        event.returnValue = message; // Show warning on tab close
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [blockCondition, message]);

  const confirmNavigation = () => {
    if (blocker.state === "blocked") blocker.proceed();
  };

  const cancelNavigation = () => {
    if (blocker.state === "blocked") blocker.reset();
  };

  const nextLocation = blocker.state === "blocked" ? blocker.location : null;

  return { confirmNavigation, cancelNavigation, nextLocation };
};

export default useBlocker;
